module.exports = __webpack_public_path__ + "images/social-icons/facebook-icon.924fa868f666d82c8ff0.svg";